import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Experience } from '../experience.model';
import { Interaction } from '../../interactions/interaction.model';
import { NgbCalendar, NgbDate, NgbDateStruct, NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { ExperiencesService } from '../experiences.service';
import { PrizesService } from '../../prizes/prizes.service';
import { InteractionsService } from '../../interactions/interactions.service';
import * as moment from 'moment';
import 'moment/locale/it';
import {environment} from '../../../../environments/environment';
import { ToastyService } from 'ng2-toasty';
import { config, from, Observable } from 'rxjs';
import {Location} from '@angular/common';
import { SortableOptions } from 'sortablejs';
import { Prize } from '../../prizes/prize.model';

@Component({
  selector: 'app-int-group-exp',
  templateUrl: './int-group-exp.component.html',
  styleUrls: ['./int-group-exp.component.scss'],
  providers:[NgbDropdownConfig]
})
export class IntGroupExpComponent implements OnInit {

  environment = environment;
  moment = moment;
  breadcrumb = [];
  interactions: Interaction[] = [];
  filteredInteractions: Interaction[] = [];
  searchFilter: string;
  intDetailsOpened;
  intDetailValid = false;
  prizes: Prize[];
  selectedInt: Interaction;
  // experience: any = {id: 1, title:"My first Experience",interactions: [{id:12,title:"Benvenutissimo",interactionType:"statica"},{id:111,title:"Palazzo Reale",interactions:[{id:2,title:"Giardino",interactionType:"quiz"},{id:3,title:"Biglietteria",interactionType:"quiz"},{id:222,title:"Primo Piano",interactions:[{id:4,title:"Stanza1 del piano 1",interactionType:"quiz"},{id:5,title:"Stanza2 del piano 1",interactionType:"quiz"}]},{id:333,title:"Secondo Piano",data:null,interactions:[{id:6,title:"Stanza1 del piano 2",interactionType:"quiz"},{id:7,title:"Stanza2 del piano 2",interactionType:"quiz"}]}]},{id:8,title:"Arrivederci",interactionType:"statica"}]};
  expId: number = null;
  groupId: number = null;
  experience: any = {};
  tree: any = {};
  node: any = [];
  currentGroup: any = null;
  folderId: number;
  expSegment = 'list';
  sortablejsOptions: SortableOptions = {
    onUpdate: (event: any) => {
      this.experience.updatedAt = moment().format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
      const newOrders = this.convert(this.node.interactions).map( (el) => {
        return el.id;
      });
      
      this.expService.editIntOrGroupOrder(this.experience.id, newOrders)
      .subscribe((res) => {
        this.expService.getExpTree(this.expId)
          .subscribe((res: {data: any}) => {
            this.tree = res.data;
            console.log('COMPLETE TREE', this.tree);
            this.node = this.getCurrentNode(this.tree, this.folderId);
            this.initBreadcrumb(this.experience.title, this.experience.id);
          },
          (err) => {
            console.log('Errore ', err.error.message);
          });
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
    }
  }
  experienceForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    info: new FormControl(''),
    tipologia: new FormControl('gioco', [Validators.required]),
    video: new FormControl(''),
    image: new FormControl(null, [Validators.required]),
    primaryColor: new FormControl('#73BCCA', [Validators.required]),
    hasPeriod: new FormControl(false, [Validators.required]),
    startDate: new FormControl(''),
    endDate: new FormControl(''),
    fixedOrder: new FormControl(false),
    mapType: new FormControl('disabled'),
    hasPrizes: new FormControl(false),
    status: new FormControl(false, [Validators.required])
  });

  pickerPlaceholderColor = '#ffffff';
  hoveredDate: NgbDateStruct | null = null;
  fromDate: NgbDateStruct;
  toDate: NgbDateStruct | null = null;
  mapData = null;

  @ViewChild('groupName') groupName;
  @ViewChild('onlineModal') onlineModal;
  @ViewChild('pubblicaModal') pubblicaModal;
  @ViewChild('intDetailsModal') intDetailsModal;
  @ViewChild('groupOptionsModal') groupOptionsModal;
  @ViewChild('groupMapModal') groupMapModal;

  
  maxPoints: number = 0;

  constructor(
    private expService: ExperiencesService,
    private intService: InteractionsService,
    private prizesService: PrizesService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private toastyService: ToastyService,
    private formBuilder: FormBuilder,
    private config: NgbDropdownConfig,
    public location: Location,
    private calendar: NgbCalendar
    ) { 
      config.placement = 'bottom-right';
    }

  async ngOnInit(): Promise<void> {

    this.expId = this.activatedRoute.snapshot.params.id;
    this.folderId = this.activatedRoute.snapshot.params.folderId;

    // OTTENGO I DATI DELL'EXPERIENCE
    this.expService.getOneExperience(this.expId)
    .subscribe((res: {data: Experience}) => {
      this.experience = res.data;
      console.log('experience', res.data);
      this.fillForm(this.f('experienceForm'), this.experience);
      // OTTENGO I DATI DEL TREE
      this.expService.getExpTree(this.expId)
      .subscribe((res: {data: any}) => {
        this.tree = res.data;
        console.log('COMPLETE TREE', this.tree);
        this.node = this.getCurrentNode(res.data, this.folderId);
        this.initBreadcrumb(this.experience.title, this.experience.id);
      },
      (err) => {
        console.log('Errore ', err);
      });
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });

    // OTTENGO I DATI DI TUTTE LE INTERACTIONS
    this.intService.getAllInteractions()
    .subscribe((res: {data: any}) => {
      this.interactions = res.data;
      this.filteredInteractions = [...res.data];
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });

    // OTTENGO I DATI DI TUTTI I PRIZES
    this.prizesService.getAllPrizes()
    .subscribe((res: {data: any[], message: string}) => {
      this.prizes = res.data;
      // create a points controller foreach prize
      // this.createPrizesPointsControls();
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });

  }


  //------------------------------------------------------------------------------------------------------------//
  //------------------------------------------------INIT-------------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  // INIZIALIZZO IL BREADCRUMB
  initBreadcrumb(title: string, expId: number) {
    this.breadcrumb = [
    {
      breadcrumbs: true,
      title: 'Experiences',
      type: 'collapse',
      url: '/experiences'
    },
    {
      breadcrumbs: true,
      title: title,
      type: 'item',
      url: '/experiences/' + expId
    }
  ];
  }

  // PRECOMPILO IL FORM CON I DATI RICEVUTI DA DB
  fillForm(form, data) {
    form.title.setValue(data.title);
    form.description.setValue(data.description);
    data.extra && data.extra.info ? form.info.setValue(data.extra.info) : form.info.setValue('');
    data.extra && data.extra.video ? form.video.setValue(data.extra.video) : form.video.setValue('');
    data.extra && data.extra.type ? form.tipologia.setValue(data.extra.type) : form.tipologia.setValue('');
    form.image.setValue(data.image);
    data.startDate !== null && form.hasPeriod.setValue(true);
    this.fromDate = {
      year: +moment(data.startDate, 'YYYY-MM-DD').format('YYYY'),
      month: +moment(data.startDate, 'YYYY-MM-DD').format('MM'),
      day: +moment(data.startDate, 'YYYY-MM-DD').format('DD')
    }
    this.toDate = {
      year: +moment(data.endDate, 'YYYY-MM-DD').format('YYYY'),
      month: +moment(data.endDate, 'YYYY-MM-DD').format('MM'),
      day: +moment(data.endDate, 'YYYY-MM-DD').format('DD')
    }
    form.startDate.setValue(data.startDate);
    form.endDate.setValue(data.endDate);
    form.fixedOrder.setValue(data.fixedOrder);
    form.mapType.setValue(data.mapType);
    console.log('dddd', data.mapType);
    form.hasPrizes.setValue(data.hasPrizes);
    form.status.setValue(data.status);

    // not in form variables
    data.mapType === 'image'
      this.mapData = data.mapData;
    
  }


  //------------------------------------------------------------------------------------------------------------//
  //------------------------------------------------MISC-------------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  // convenience getter for easy access to form fields
  // RESTITUISCO I CONTROLLER DEL FORM PASSATO COME PARAM formName: string
  f(formName: string): any { return this[formName].controls; }

  // IMPOSTA L'URL DELL'IMMAGINE IN EVIDENZA RICEVUTO DALL'EVENTO SCATENATO DAL COMPONENTE app-media-manager
  // SE IL TARGET E' UN CONTROLLER ASSOCIA LA IMMAGINE AL CONTROLLER
  // SE NON è UN CONTROLLER ASSOCIA LA IMMAGINE A mapData.imagePath
  setImageUrl(event, formName, formControl?): void {
    if (event) {
      if (formName) {
        if (formName === 'currentGroup') {
          this.currentGroup.mapData = {
            ...this.currentGroup.mapData,
            imagePath: event.filename
          }
          return;
        }
        if (formName === 'group') {
          this.currentGroup.image = event.filename;
          return;
        }
        if (formName === 'rightImage' || formName === 'wrongImage') {
          this.intDetailsOpened[formName] = event.filename;
          return;
        }
        this.f(formName)[formControl].setValue(event.filename);
      } else {
        this.mapData = {
          ...this.experience.mapData,
          imagePath: event.filename
        }; 
      }
    } else {
      if (formName) {
        if (formName === 'currentGroup') {
          this.currentGroup.mapData = {
            ...this.currentGroup.mapData,
            imagePath: null
          }
          return;
        }
        if (formName === 'group') {
          this.currentGroup.image = null;
          return;
        }
        if (formName === 'rightImage' || formName === 'wrongImage') {
          this.intDetailsOpened[formName] = null;
          return;
        }
        this.f(formName)[formControl].setValue(null);
      } else {
        this.mapData = {
          ...this.experience.mapData,
          imagePath: null
        }; 
      }
    }
  }

  // Depth First Search - algoritmo di ricerca in un array deep nested
  dfs(obj, targetId) {
    if (obj.groupId === targetId) {
      return obj
    }
    if (obj.interactions) {
      for (let item of obj.interactions) {
        let check = this.dfs(item, targetId);
        if (check) {
          return check
        }
      }
    }
    return null
  }

  // CONVERTE L'ALBERO IN LISTA FLAT DI INTERACTION E GRUPPI
  convert(tree): any[] {
    //console.log('tere', tree);
    return tree.reduce((acc, o) => {
        if (o.nodeType !== 'group') { // E' UN INTERACTION
          acc.push({
            id: o.id,
            parentId: o.parentId,
            nodeType: o.nodeType,
            order: o.order,
            points: o.points,
            title: o.title,
            coordinates: o.coordinates
          });
        } else { // E' UN GRUPPO
          acc.push({
            id: o.id,
            groupId: o.groupId,
            parentId: o.parentId,
            nodeType: 'group',
            mapType: o.mapType,
            order: o.order,
            points: o.points,
            title: o.title,
            coordinates: o.coordinates
          });
          acc = acc.concat(this.convert(o.interactions));
        }
        return acc;
    }, []);
  }

  // NAVIGAZIONE SEGMENTI (OPZIONI EXPERIENCE)
  setExpSegment(event): void {
    console.log('event', event);
    switch (event) {
      case 'edit':
        this.node = this.getCurrentNode(this.tree);
        this.location.go( '/experiences/' + this.expId);
        this.expSegment = event;
        break;
      case 'prize':
        this.getMaxPoints();
        this.expSegment = event;
      default:
        this.expSegment = event;
        break;
    }
  }

  toastSavedAsDraft(): void {
    this.toastyService.success({
      title: 'Experience salvata in bozza',
      msg: 'Tutti i dati della tua Experience "<b>' + this.experience.title + '</b>" sono stati salvati come bozza.<br><small>La versione online della tua Experience non è stata modificata.</small>'
    });
  }

  showToast(type: 'success' | 'error', title: string, message: string) {
    this.toastyService[type]({
      title: title,
      msg: message
    });
  }


  //------------------------------------------------------------------------------------------------------------//
  //------------------------------------------------ASPETTO----------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  // IMPOSTA IL PRIMARY COLOR
  colorPickerPlaceholderLight(color): void {
    const c = color.substring(1);      // strip #
    const rgb = parseInt(c, 16);   // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff;  // extract red
    const g = (rgb >>  8) & 0xff;  // extract green
    const b = (rgb >>  0) & 0xff;  // extract blue
    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    this.experience.styleData = {primaryColor: color};

    if (luma < 100) {
      this.pickerPlaceholderColor = '#ffffff';
    } else {
      this.pickerPlaceholderColor = '#333333';
    }
  }


  //------------------------------------------------------------------------------------------------------------//
  //------------------------------------------------PRIZES-----------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  // IMPOSTO I PUNTI AD UN PRIZE (SOLO LATO CLIENT)
  setPrizePoints(id: number | string, event: any ): void {
    if (+event.target.value > this.maxPoints) {
      event.target.value = this.maxPoints;
    }
    const prize = this.experience.prizes.find(p => p.id === id);
    if (prize) {
      if (event.target.value === '') {
        prize.score = undefined;
      } else {
        prize.score = +event.target.value;
      }
    }
  }

  // OTTENGO IL PUNTEGGIO DEL PRIZE
  getPrizePoints(id: number): number {
    if (this.experience.prizes.find(p => p.id === id)) {
      return this.experience.prizes.find(p => p.id === id).score;
    } else {
      return 0;
    }
  }

  // ASSOCIO IL PREMIO ALLA EXPERIENCE (SOLO LATO CLIENT)
  selectPrize(id: number | string): void {
    const prize = this.prizes.find(p => p.id === +id);
    if (!this.experience.prizes.find(p => p.id === +id)) {
      this.experience.prizes.push(prize);
    } else {
      this.experience.prizes = this.experience.prizes.filter(p => p.id !== +id);
    }
  }

 /*  // DISASSOCIO IL PREMIO ALLA EXPERIENCE (SOLO LATO CLIENT)
  deselectPrize(id: number | string): void {
    this.experience.prizes = this.experience.prizes.filter(p => p.id !== id);
    // TODO: delete prize in experience call
  } */

  // RETURN TRUE SE IL PRIZE è PRESENTE NEGLI EXPERIENCE.PRIZE
  isPrizeActive(id: number): boolean {
    if (this.experience.prizes.find(p => p.id === id)) {
      return true;
    } else {
      return false;
    }
  }

  // CHIAMATA AL SERVER PER AVERE PUNTEGGIO MASSIMO OTTENIBILE NELL'EXPERIENCE
  getMaxPoints(): void{
    this.expService.getMaxPoints(this.experience.id)
    .subscribe((res: {maxPoints: number}) => {
      this.maxPoints = res.maxPoints;
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  getIntDetails(intId: number): void {
    this.expService.getIntDetails(intId)
    .subscribe((res: {data: any}) => {
      this.intDetailsOpened = res.data;
      if (!this.intDetailsOpened.extra) this.intDetailsOpened.extra = {type: null};
      this.intDetailsModal.show(); 
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }
  
  setIntDetails(target: string, event: any) {
    this.intDetailsOpened[target] = event.target.value;
  }

  saveIntDetails(int): void {
    this.intDetailValid = false;
    console.log('int', int);
    this.expService.editInteractionDetails(
      int.id,
      int.rightAnswer,
      int.wrongAnswer,
      int.rightImage,
      int.wrongImage,
      int.timeLimit,
      int.points,
      int.extra
    ) .subscribe((res: {data: any}) => {
        this.tree = res.data;
        console.log('COMPLETE TREE', this.tree);
        this.node = this.getCurrentNode(res.data, this.folderId);
        this.initBreadcrumb(this.experience.title, this.experience.id);
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  //------------------------------------------------------------------------------------------------------------//
  //------------------------------------------------VALIDATION-------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//


  validateConfigurazione(): boolean {
    const form = this.f('experienceForm');
    if (!form.title.errors && !form.description.errors && !form.tipologia.errors)
      return true
    return false
  }

  validateAspetto(): boolean {
    const form = this.f('experienceForm');
    if (!form.image.errors && !form.primaryColor.errors)
      return true
    return false
  }

  validatePeriodo(): boolean {
    const form = this.f('experienceForm');
    if (form.hasPeriod.value && (form.startDate.value!== null && form.startDate.value!== null)) 
      return true;
    if (!form.hasPeriod.value)
      return true;
    return false;
  }

  validateNavigazione(): boolean {
    const form = this.f('experienceForm');
    if (form.mapType.value === 'image' && !this.mapData) return false;
    return true;
  }

  // RETURN TRUE SE ALMENO UNA INTERAZIONE E' STATA INSERITA NELLA MAPPA
  validateIntsOnMap(isGroup? : boolean): boolean {
    if (!isGroup) {
      if (this.mapData && this.node.interactions.filter(el => el.coordinates).length){
        return true;
      }
    } else {
      if (this.currentGroup.mapData && this.node.interactions.filter(el => el.coordinates).length){
        return true;
      }
    }
    return false;
  }

  // RETURN TRUE SE OGNI PRIZE SELEZIONATO HA UNO SCORE VALIDO
  validatePrizesPoints(): boolean {
    let valid = true;
    for (const prize of this.experience.prizes) {
      if (prize.score !== undefined && prize.score !== null && prize.score >= 0) {
        //
      } else {
        valid = false;
      }
    }
    return valid;
  }

  validateExperience(): void {
    const list = this.convert(this.tree.interactions);
    if (!this.experienceForm.valid) { this.showToast('error', 'Configurazione incompleta', 'La configurazione dell\'Experience non è completa!'); return;}
    if (!this.tree.interactions) { this.showToast('error', 'Configurazione incompleta', 'Ogni Experience deve avere almeno una Interaction'); return;}
    if (!this.tree.interactions.length) { this.showToast('error', 'Configurazione incompleta', 'Ogni Experience deve avere almeno una Interaction'); return;}
    if (this.areThereEmptyGroup(list)) { this.showToast('error', 'Configurazione incompleta', 'Il gruppo ' + this.areThereEmptyGroup(list) + ' non ha nessuna Interaction'); return;}
    if (this.experience.hasPrizes) {
      if (!this.experience.prizes || !this.experience.prizes.length) { this.showToast('error', 'Configurazione incompleta', 'Ad Una Experience a premi devi associare almeno un premio!'); return;}
      if (this.unreacheablePrizes(list)) { this.showToast('error', 'Configurazione incompleta', 'Uno o più premi non sono raggiungibili con il completamento di tutte le Interactions. Rivedi i punteggi dei premi o delle Interactions'); return;}
    }
    if (this.experience.mapType !== 'disabled') {
      if (!this.mapData) { this.showToast('error', 'Configurazione incompleta', 'La configurazione della mappa di navigazione della Experience non è completa'); return;}
      if (!this.tree.interactions.filter(i => i.coordinates).length) { this.showToast('error', 'Configurazione incompleta', 'La configurazione della mappa di navigazione della Experience non è completa'); return;}
    }
    // controllo se tutti i gruppi che hanno mapType !== 'disabled' hanno all'interno almeno una interazione con coordinate
    console.log('list', list);
    let found = false;
    list.forEach(n => {
      if (n.nodeType === 'group' && n.mapType !== 'disabled') {
        if (!list.find(i => i.parentId === n.groupId && i.coordinates)) {
          this.showToast('error', 'Configurazione incompleta', 'Il gruppo ' + n.title + ' ha una mappa di navigazione ma non ci sono interazioni mappate al suo interno.');
          found = true;
        }
      }
    })
    if (found) return
     

    this.pubblicaModal.show()
  }

  areThereEmptyGroup(list): boolean | string {
    let found = false;
    list.forEach((el) => {
      if (el.nodeType === 'group') {
        const contents = list.filter(item => item.parentId === el.groupId)
        if (!contents.length) {
          found = el.title;
        }
      }
    })
    return found;
  }

  unreacheablePrizes(list): boolean {
    let found = false;
    if (this.experience.prizes.length) {
      let maxPoints = 0;
      list.forEach(item => {
        maxPoints += item.points;
      })
      this.experience.prizes.forEach(item => {
        if (item.score > maxPoints) 
          found = true;
      });
    }
    return found
  }

  validateNavigazioneGruppi(): boolean {
    if (this.currentGroup.mapType !== 'disabled' && !this.currentGroup.mapData) return false;
    if (this.currentGroup.mapType !== 'disabled' && !this.currentGroup.mapData.imagePath) return false;
    return true;
  }



  //------------------------------------------------------------------------------------------------------------//
  //--------------------------------------------SCRITTURA SU SERVER--------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  // IMPOSTO GLI SCORE A TUTTI I PRIZES SELEZIONATI (LATO SERVER)
  setPrizesPoints(): void {
    const prizesScore = [];
    for (let i = 0; i < this.experience.prizes.length ; i++) {
      prizesScore.push({
        prizeId: this.experience.prizes[i].id,
        experienceId: this.experience.id,
        score: this.experience.prizes[i].score
      });
    }
    // CHIAMATA A setPrizeScore
    this.expService.setPrizesScore(prizesScore)
    .subscribe((res: {data: any[], message: string}) => {
      this.experience.updatedAt = moment().format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
      this.expService.getExpTree(this.expId)
      .subscribe((res: {data: any}) => {
        this.tree = res.data;
        console.log('COMPLETE TREE', this.tree);
        this.node = this.getCurrentNode(this.tree);
        this.initBreadcrumb(this.experience.title, this.experience.id);
        this.expSegment = 'list';
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
    },
    (err) => {
      console.log('Errore ', err.error.message);
      this.toastyService.error({
        title: 'Errore nel Salvataggio',
        msg: 'Non è stato possibile salvare i prizes selezionati.'
      });
    });
  }

  // SALVA LE MODIFICHE SULLA TEMPORARY EXPERIENCE (LATO SERVER)
  saveExperience(): void {
    this.groupMapModal.hide();
    const form = this.f('experienceForm');

    
    this.experience = {
      ...this.experience,
      experienceId: this.experience.id,
      title: form.title.value,
      description: form.description.value,
      extra: {
        info: form.info.value,
        video: form.video.value,
        type: form.tipologia.value
      },
      image: form.image.value,
      startDate: form.startDate.value,
      endDate: form.endDate.value,
      fixedOrder: form.fixedOrder.value,
      mapType: form.mapType.value,
      styleData: form.primaryColor.value && {primaryColor: form.primaryColor.value},
      mapData: this.mapData ? this.mapData : this.experience.mapData,
      hasPrizes: form.hasPrizes.value,
      status: form.status.value
    }

    const mapData = this.node.interactions
    .map(i => {
        return {
          id: i.id,
          coordinates: i.coordinates
        }
    })

    // AGGIORNO INTEXP
    this.expService.updateMapData(mapData)
    .subscribe((res: {data: any}) => {
      console.log('response', res);
       // AGGIORNO EXPERIENCE
      this.expService.editExperience(this.experience)
      .subscribe((res: {data: any}) => {
        this.expService.getExpTree(this.expId)
        .subscribe((res: {data: any}) => {
          this.tree = res.data;
          this.initBreadcrumb(this.experience.title, this.experience.id);
          console.log('COMPLETE TREE', this.tree);
          this.node = this.getCurrentNode(this.tree, this.folderId);
          this.expSegment = 'list';
          this.showToast('success', 'Experience salvata!', 'La tua Experience è stata salvata correttamente')
        },
        (err) => {
          console.log('Errore ', err.error.message);
        });
      },
      (err) => {
        console.log('Errore ', err);
      });
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });

   

    
  }

  // IMPOSTA LO STATUS DELL'EXPERIENCE E DELLA TEMPORARY A "deleted"
  deleteExperience(): void {
    this.expService.changeStatus(this.experience.originalId, 'deleted')
      .subscribe((res) => {
        this.router.navigate(['/experiences']);
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
      this.expService.changeStatus(this.experience.id, 'deleted')
      .subscribe((res) => {
        this.router.navigate(['/experiences']);
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
  }

  // ELIMINA LA TEMPORARY E RIPRISTINA L'EXPERIENCE CON I DATI DELLA EXP ORIGINALE
  resetToOriginal(): void {
    this.expService.deleteTemporary(this.experience.id, this.experience.originalId)
      .subscribe((res) => {
        /* this.expService.getOneExperience(this.activatedRoute.snapshot.params.id)
        .subscribe((res: {data: Experience}) => {
          this.experience = res.data;
          this.toastyService.success({
            title: 'Experience ripristinata',
            msg: 'La tua Experience "<b>' + this.experience.title + '</b>" è stata ripristinata all\'ultima versione pubblicata.'
          });
          this.fillForm(this.f('experienceForm'), this.experience);
          // OTTENGO I DATI DEL TREE
          this.expService.getExpTree(this.expId)
          .subscribe((res: {data: any}) => {
            this.tree = res.data;
            console.log('COMPLETE TREE', this.tree);
            this.node = this.getCurrentNode(res.data, this.folderId);
            this.initBreadcrumb(this.experience.title, this.experience.id);
          },
          (err) => {
            console.log('Errore ', err);
          });
          
        },
        (err) => {
          console.log('Errore nel get', err.error.message);
        }); */
        this.toastyService.success({
          title: 'Experience ripristinata',
          msg: 'La tua Experience "<b>' + this.experience.title + '</b>" è stata ripristinata all\'ultima versione pubblicata.'
        });
        this.router.navigate(['/experiences']);
      },
      (err) => {
        console.log('Errore nel delete', err);
      });
  }

  // SE LA CONFIGURAZIONE DELL'EXP E' COMPLETA MOSTRA IL MODALE CON LA SCELTA DI SALVATAGGIO
  // SE NON E' COMPLETA MOSTRA TOAST CON AVVISO
  changeExperienceStatus(event): void {
    if (this.experience.status) {
      this.validateExperience();
    } else {
      this.putItOffline();
    }
  }

  // IMPOSTA LO STATO DELL'EXPERIENCE A "online"
  putItOnline(): void {
    this.expService.changeStatus(this.experience.originalId, 'online')
      .subscribe((res) => {
        this.experience.status = 'online';
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
      this.expService.changeStatus(this.experience.id, 'online')
      .subscribe((res) => {
        this.experience.status = 'online';
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
  }

  // IMPOSTA LO STATO DELL'EXPERIENCE A "offline"
  putItOffline(): void {
    this.expService.changeStatus(this.experience.originalId, 'offline')
      .subscribe((res) => {
        this.experience.status = 'offline';
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
      this.expService.changeStatus(this.experience.id, 'offline')
      .subscribe((res) => {
        this.experience.status = 'offline';
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
  }

  // PUBBLICA EXPERIENCE
  setExperienceToOnline(): void {
    this.expService.setExperienceToOnline(this.experience.originalId, this.experience.id)
    .subscribe((res) => {
      this.toastyService.success({
        title: 'Experience pubblicata',
        msg: 'La tua Experience "<b>' + this.experience.title + '</b>" è stata pubblicata correttamente ed è online.'
      });
      this.router.navigate(['/experiences']);
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  saveGroup(): void {
    const group = {
        id: this.currentGroup.id,
        title: this.currentGroup.title,
        description: this.currentGroup.description,
        extra: this.currentGroup.extra,
        image: this.currentGroup.image,
        styleData: this.currentGroup.styleData,
        fixedOrder: this.currentGroup.fixedOrder,
        mapType: this.currentGroup.mapType,
        mapData: this.currentGroup.mapData,
        parentId: this.currentGroup.parentId,
        experienceId: this.currentGroup.experienceId
      }
    this.expService.editGroup(group)
    .subscribe((res: {data: any}) => {
      console.log('risposta', res);
      this.expService.getExpTree(this.expId)
        .subscribe((res: {data: any}) => {
          this.tree = res.data;
          this.initBreadcrumb(this.experience.title, this.experience.id);
          console.log('COMPLETE TREE', this.tree);
          this.node = this.getCurrentNode(this.tree, this.folderId);
          this.expSegment = 'list';
          this.showToast('success', 'Gruppo salvato!', 'il tuo gruppo è stato salvato correttamente')
        },
        (err) => {
          console.log('Errore ', err.error.message);
        });
      this.groupOptionsModal.hide();
      this.groupMapModal.hide();
    },
    (err) => {
      console.log('Errore ', err);
    });
  }

  //------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------DATE PICKER--------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  // GESTISCE LA SELEZIONE DELLE DATE NEL DATEPICKER
  onDateSelection(date: NgbDate): void {
    const form = this.f('experienceForm');
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      form.startDate.setValue(null);
      form.startDate.setValue(null);
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.updatePeriodoExperience();
    } else {
      this.toDate = null;
      form.endDate.setValue(null);
      form.startDate.setValue(null);
      this.fromDate = date;
    }
  }

  // AGGIORNA CONTROLLER FORM startDate e endDate CON DATE SELEZIONATE DAL DATEPICKER e formattate correttamente
  updatePeriodoExperience(): void {
    const form = this.f('experienceForm');
    form.startDate.setValue(
      moment(this.fromDate.year + '-' + (this.fromDate.month) + '-' +  this.fromDate.day
      , 'YYYY-MM-DD')
      .format('YYYY-MM-DD')
    );
    form.endDate.setValue(
      moment(this.toDate.year + '-' + (this.toDate.month) + '-' +  this.toDate.day
      , 'YYYY-MM-DD')
      .format('YYYY-MM-DD')
    );
  }

  isHovered(date: NgbDate): boolean {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }
  isInside(date: NgbDate): boolean {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }
  isRange(date: NgbDate): boolean {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }


  //------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------INTERACTIONS MAP---------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//
  
  getIntsOnMap(target: string): Interaction[] {
    if (this[target].interactions.length) {
      return this[target].interactions.filter(i => i.coordinates);
    } else
    return [];
  }

  // AGGIORNA LE INTERAZIONI SULLA MAPPA IN ARRIVO DALL'EVENTO SCATENATO DAL COMPONENTE app-image-map 
  // MODIFICO IL TARGET
  // il salvataggio lato server avviene con metodo "saveExperience"
  setIntsOnMap(event): void {
    console.log('event ', event);
    if (event.length) {
      event.forEach(el => {
        this.node.interactions = this.node.interactions.map(i => {
        if (i.id === el.id) {
          return {
            ...i,
            coordinates: el.coordinates
          }
        } else {
          return i
        }
      })
    });
    } else {
      this.node.interactions = this.node.interactions.map(i => {
        return {
          ...i,
          coordinates: null
        }
      })
    }
   
    /* switch (target) {
      case 'experience':
        this.mapData = {
          ...this.mapData,
          interactions: event
        };
        break;
      case 'currentGroup':
        this.currentGroup.mapData = {
          ...this.currentGroup.mapData,
          interactions: event
        };
        break;
    
      default:
        break;
    } */
  }

  //------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------------TREE---------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  // RESTITUISCE IL NODO CORRENTE
  // SE folderId è NULL ALLORA RESTITUISCE l'ALBERO COMPLETO
  getCurrentNode(node: any, folderId?: number): any {
    let result = null;
    if (folderId) {
      for (let n of node.interactions) {
        result = this.dfs(n, + folderId)
        if (result) {
          console.log('%c CURRENT NODE', 'background: #222; color: #bada55', result);
          return result; 
        }
      }
    } else {
      console.log('%c CURRENT NODE', 'background: #222; color: #bada55', node);
      return node;
    }
  }

  // NAVIGO ALL'INTERNO DI UN GRUPPO
  // VIENE MODIFICATO IL PATH MA NON CAMBIA LA ROTTA
  // EVITANDO DI INIZIALIZZARE NUOVAMENTE QUESTO COMPONENTE
  openGroup(id: number) {
    this.location.go(this.location.path() + '/' + id);
    this.folderId = id;
    this.node = this.getCurrentNode(this.node, id);
    console.log('PATH',this.location.path()); 
  }

  // NAVIGAZIONE DA GRUPPO A PARENT
  backToParent(): void {
    this.location.go(this.location.path().replace('/'+ this.folderId, ''));
    let location = this.location.path().split("/");
    if (location[location.length - 2] !== 'experiences') {
      this.folderId = +location[location.length - 1];
      this.node = this.getCurrentNode(this.tree, this.folderId);
    } else {
      this.folderId = null;
      this.node = this.getCurrentNode(this.tree);
    }
  }

  //------------------------------------------------------------------------------------------------------------//
  //-------------------------------------AGGIUNTA O ELIMINAZIONE GRUPPI O INT-------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------//

  gimmeNewOrder(node): number {
    const currentNodeList = this.convert(node.interactions);
    return +currentNodeList[currentNodeList.length-1].order + 1;
      
  }


  addGroup(name): void {
    this.expService.addNewGroup(this.experience.id, name.value, this.folderId)
    .subscribe((res: {data: any}) => {
      const newGroup = res.data;
      console.log('res', res.data);
      let newIntOrder = null
      if (this.node.interactions.length) {
        newIntOrder = this.gimmeNewOrder(this.node);
      } else {
        newIntOrder = this.node.order + 1;
      }
      if (!newIntOrder) newIntOrder = 1;
      this.expService.addIntOrGroupToExp(this.experience.id, null, res.data.id, newIntOrder)
      .subscribe((res: {data: any}) => {
        this.node.interactions.push({
          ...newGroup,
          id: res.data.id,
          order: newIntOrder,
          groupId: newGroup.id,
          nodeType: 'group',
          interactions:[]
        });
        this.groupName.nativeElement.value = '';
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  addInteraction(): void {
    console.log('addInteraction');
    let newIntOrder = null
    if (this.node.interactions.length) {
      newIntOrder = this.gimmeNewOrder(this.node);
    } else {
      newIntOrder = this.node.order + 1;
    }
    if (!newIntOrder) newIntOrder = 1;
    this.expService.addIntOrGroupToExp(this.experience.id, +this.selectedInt.id, this.folderId ? +this.folderId : null, newIntOrder)
      .subscribe((res) => {
        this.selectedInt = null;
        this.expService.getExpTree(this.expId)
          .subscribe((res: {data: any}) => {
            this.tree = res.data;
            console.log('COMPLETE TREE', this.tree);
            this.node = this.getCurrentNode(this.tree, this.folderId);
            this.initBreadcrumb(this.experience.title, this.experience.id);
          },
          (err) => {
            console.log('Errore ', err.error.message);
          });
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
    
    
  }

  deleteInt(id: number): void {
    this.expService.deleteInteractionFromExperience(id)
    .subscribe((res) => {
      this.expService.getExpTree(this.expId)
          .subscribe((res: {data: any}) => {
            this.tree = res.data;
            console.log('COMPLETE TREE', this.tree);
            this.node = this.getCurrentNode(this.tree, this.folderId);
            this.initBreadcrumb(this.experience.title, this.experience.id);
          },
          (err) => {
            console.log('Errore ', err.error.message);
          });
      //this.node.interactions = this.node.interactions.filter(i => i.id !== id);
      // TODO: Se il nodo ha una mappa 'image' o 'geo'
      // elimino l'interazione da mapData.interactions
      /* if (!this.node.groupId) { // sono nella root principale
        this.tree.interactions = this.tree.interactions.filter(i => i.id !== id)
      } else {
        this.expService.getGroup(this.folderId)
        .subscribe((res: { data: any}) => {
            this.currentGroup = res.data;
            this.node.interactions = this.node.interactions.filter(i => i.id !== id);
            this.saveGroup();
        },
        (err) => {
          console.log('Errore ', err.error.message);
        });
      } */
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  deleteGroup(id: number): void {
    this.expService.deleteGroupFromExperience(id)
    .subscribe((res: any) => {
      console.log('res', res.message);
      this.expService.getExpTree(this.expId)
          .subscribe((res: {data: any}) => {
            this.tree = res.data;
            console.log('COMPLETE TREE', this.tree);
            this.node = this.getCurrentNode(this.tree, this.folderId);
            this.initBreadcrumb(this.experience.title, this.experience.id);
          },
          (err) => {
            console.log('Errore ', err.error.message);
          });
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  editGroupOptions(event: {type: string, id: number}) {
    this.expService.getGroup(this.folderId)
    .subscribe((res: { data: any}) => {
        this.currentGroup = res.data;
        console.log('questo è il gruppo', this.currentGroup);
        if (!this.currentGroup.extra) this.currentGroup.extra = {type: null, coordinates: {lat: null, lng: null}};
        if (event.type === 'edit') {
          this.groupOptionsModal.show()
        } else {
          this.groupMapModal.show();
        }
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  createNewInt(): void {
    const queryParams = { expPath: this.location.path(), tempExpId: this.experience.id , order: this.node.interactions.length ? this.gimmeNewOrder(this.node) : this.node.order + 1}
    this.router.navigate(['/interactions/new'], {queryParams: queryParams});
  }


}
